module.exports = __webpack_public_path__ + "img/betsy-ross.1cf62c38.png";